import React from 'react';
import PropTypes from 'prop-types';
import {
  Marker,
  Popup,
} from 'react-leaflet';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Map from '../Map';
import 'leaflet/dist/leaflet.css';
import CardList from '../CardList';

const StyledLocationList = styled.div`
  .Location--Map {
    grid-area: map;
    height: 100%;
  }

  .LocationList--filter-cards-wrapper {
    grid-area: cards;
  }

  .LocationList--filter-group {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }

  .LocationList--filter {
    display: inline-flex;
    margin: 0.5rem 1rem;

    select {
      display: inline-block;
      margin-left: auto;
    }
  }

  @media(min-width: ${t => t.theme.desktopBreakpoint}) {
    width: 100%;
    max-height: 100vh;
    overflow: hidden;
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-template-areas: 'cards map';

    .Location--Map {
      height: 100vh;
    }

    .LocationList--filter-cards-wrapper {
      margin-top: 1.5rem;
      height: 100vh;
      max-height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    .Card-list {
      max-height: 100%;
      margin-bottom: 0;
      overflow: auto;
    }
  }
`;

const propTypes = {
  arr: PropTypes.arrayOf(PropTypes.shape({
    image: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    route: PropTypes.string.isRequired,
    summary: PropTypes.string.isRequired,
  })),
  className: PropTypes.string,
};

const defaultProps = {
  arr: null,
  className: null,
};

const filterOptions = [
  {
    key: 'parking',
    label: 'Parking',
  },
  {
    key: 'washrooms',
    label: 'Washrooms',
  },
  {
    key: 'wheelchairWashrooms',
    label: 'Wheelchair Accesible Washrooms',
  },
  {
    key: 'boatLaunch',
    label: 'Boat Launch',
  },
  {
    key: 'boatRental',
    label: 'Boat Rentals',
  },
  {
    key: 'fishObservation',
    label: 'Fish Observation',
  },
  {
    key: 'ttc',
    label: 'TTC',
  },
  {
    key: 'telephone',
    label: 'Telephone',
  },
  {
    key: 'userFee',
    label: 'User Fee',
  },
  {
    key: 'disabledAccess',
    label: 'Disabled Access',
  },
  {
    key: 'iceFishing',
    label: 'Ice Fishing',
  },
];

/**
 * Determine if an attribute matches the conditions needed to be filtered out.
 *
 * @param {boolean|null} filter
 * @param {boolean} locationComparison
 *
 * @return boolean
 */
function shouldAttributeBeFiltered(filter, locationComparison) {
  if (filter !== null && filter !== locationComparison) {
    return true;
  }
  return false;
}

class LocationList extends React.Component {
  constructor(props) {
    super(props);

    const { arr, className } = this.props;
    const filteredLocations = arr || [];

    this.state = {
      arr,
      filteredLocations,
      className,
      filter: {
        parking: null,
        washrooms: null,
        wheelchairWashrooms: null,
        boatLaunch: null,
        boatRental: null,
        fishObservation: null,
        ttc: null,
        telephone: null,
        userFee: null,
        disabledAccess: null,
        iceFishing: null,
      },
    };

    this.filterLocations = this.filterLocations.bind(this);
    this.updateFilter = this.updateFilter.bind(this);
  }

  componentWillReceiveProps({ arr }) {
    this.setState({
      arr,
      filteredLocations: arr,
    });
  }

  filterLocations() {
    const {
      filter,
      arr,
    } = this.state;

    const filteredLocations = arr.filter(location => filterOptions.every((option) => {
      const { key } = option;
      return !shouldAttributeBeFiltered(filter[key], location[key]);
    }));

    this.setState({
      filteredLocations,
    });
  }

  updateFilter(e, label) {
    let value = null;

    if (e.target.value === 'true') {
      value = true;
    } else if (e.target.value === 'false') {
      value = false;
    }

    const { filter } = this.state;
    filter[label] = value;

    this.setState({
      filter,
    }, this.filterLocations);
  }

  render() {
    const { className, filteredLocations } = this.state;
    const classNames = [className, 'Card-list'].join(' ');

    const List = (
      <CardList
        cards={filteredLocations.map(value => ({
          img: value.imageThumbnail,
          title: value.name,
          key: value.route,
          link: `/locations/${value.route}`,
          description: value.summary,
        }))}
      />
    );

    const LocationMarkers = filteredLocations.map(value => (
      <Marker
        position={value.position}
        key={value.route}
      >
        <Popup>
          <div>
            <Link to={`/locations/${value.route}`}>
              <h3>
                {value.name}
              </h3>
            </Link>
            <p>
              {value.summary}
            </p>
          </div>
        </Popup>
      </Marker>
    ));

    const filters = filterOptions.map(node => (
      <label
        key={node.key}
        htmlFor={node.key}
        className="LocationList--filter"
      >
        {node.label}
        <select id={node.key} onChange={e => this.updateFilter(e, node.key)}>
          <option value={null}>
            Any
          </option>
          <option value="true">
            Yes
          </option>
          <option value="false">
            No
          </option>
        </select>
      </label>
    ));

    return (
      <StyledLocationList>
        <Map
          center={[43.6568779, -79.42000]}
          zoom={10}
          className="Location--Map"
        >
          {LocationMarkers}
        </Map>

        <div className="LocationList--filter-cards-wrapper">
          <form className="LocationList--filter-group">
            {filters}
          </form>
          <div className={classNames}>
            {List}
          </div>
        </div>
      </StyledLocationList>
    );
  }
}

LocationList.propTypes = propTypes;
LocationList.defaultProps = defaultProps;

export default LocationList;



// WEBPACK FOOTER //
// ./src/Components/LocationList/LocationList.jsx